export default function initHeightCard() {
  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  function updateHeight(image: HTMLImageElement) {
    if (image !== null) {
      const imgHolder = image.parentNode?.parentNode as HTMLElement;
      const imgHolderHeight = image.offsetHeight;
      imgHolder.style.setProperty('--img-holder-height', `${imgHolderHeight}px`);
    }
  }

  function updateHeightOnLoad(event: Event) {
    const img = event.target as HTMLImageElement;
    updateHeight(img);
  }

  function updateAllHeights() {
    if (isTouchDevice()) return;

    document.querySelectorAll('.application-card').forEach((col) => {
      const img = col.querySelector('.application-card-image img') as HTMLImageElement;
      if (img !== null) {
        if (img.complete) {
          updateHeight(img);
        } else {
          img.onload = updateHeightOnLoad;
        }
      }
    });
  }

  updateAllHeights();
  if (!isTouchDevice()) {
    window.addEventListener('resize', updateAllHeights);
  }
}
